// Auto-generated from Merchant terms documents
export const termsOfServiceContent = {
  "en": {
    "title": "Terms and Conditions for Merchant Onboarding on the ZORY Platform",
    "subtitle": "Terms and Conditions – Official Arabic Version",
    "intro": [
      "These Terms and Conditions (“Terms”) govern the relationship between the Merchant and the ZORY Platform in relation to the Merchant’s onboarding onto the Platform, uploading products, managing them, and making them available for use within AI-powered design tools, product search, smart replacement, two-dimensional and three-dimensional designs, and any related services, tools, or dashboards.",
      "The ZORY Platform (“ZORY” or the “Platform”) is owned and operated by Prosperity Aura (“Company” or “we”). ZORY enables Merchants to display furniture and décor products within the Platform, so that such products may be used, suggested, or displayed to End Users within designs and outputs generated or supported by ZORY’s artificial intelligence systems.",
      "By joining the Platform as a Merchant, signing a commercial agreement with ZORY, paying the Subscription Fees, using the Dashboard, or uploading any products, data, or images to the Platform, you acknowledge that you have read, understood, and agreed to be bound by these Terms.",
      "If you represent a company, establishment, or legal entity, you represent that you are legally authorized to bind such entity to these Terms, and the term “Merchant” shall include such entity.",
      "If you do not agree to these Terms, you must not use the Platform or upload any products to it."
    ],
    "sections": [
      {
        "title": "Article 1 – Definitions",
        "blocks": [
          {
            "type": "paragraph",
            "text": "For the purposes of these Terms, the following terms shall have the meanings assigned to them below, unless the context requires otherwise:"
          },
          {
            "type": "paragraph",
            "text": "“ZORY” or the “Platform”: ZORY’s digital platform, including the website, applications, Dashboard, AI-powered design tools, product search tools, smart replacement tools, three-dimensional design tools, backend systems, integration interfaces, and any related services."
          },
          {
            "type": "paragraph",
            "text": "“Company”: Prosperity Aura, the owner and operator of the ZORY Platform."
          },
          {
            "type": "paragraph",
            "text": "“Merchant”: Any company or establishment that joins the ZORY Platform to upload its products and make them available within the Platform in exchange for an annual subscription."
          },
          {
            "type": "paragraph",
            "text": "“Products”: Furniture and décor products uploaded by the Merchant to the Platform or made available through technical integration, including images, descriptions, prices, dimensions, categories, links, and any other related data."
          },
          {
            "type": "paragraph",
            "text": "“Product Data”: All information related to the product, including product name, price, currency, dimensions, category, product link, image links, description, availability status, and any other technical, commercial, or descriptive data."
          },
          {
            "type": "paragraph",
            "text": "“Dashboard”: The interface provided by ZORY to the Merchant to manage, update, and delete its Products, monitor their performance, and view available interaction, conversion, and analytics data."
          },
          {
            "type": "paragraph",
            "text": "“End User”: Any person who uses the ZORY Platform to design interior spaces, search for products, review designs, or access the Merchant’s Products."
          },
          {
            "type": "paragraph",
            "text": "“Outputs”: Any design, visualization, image, recommendation, furniture arrangement, search result, replacement result, or two-dimensional or three-dimensional design displayed through the Platform."
          },
          {
            "type": "paragraph",
            "text": "“Artificial Intelligence”: ZORY’s systems, algorithms, models, and technical tools used to analyze Products, generate designs, provide recommendations, replace Products, rank visibility, and improve the user experience."
          },
          {
            "type": "paragraph",
            "text": "“Conversion”: The transfer of the End User from the ZORY Platform to the product page on the Merchant’s website through the designated link, or any other interaction measured through the Dashboard or technical integration where applicable."
          },
          {
            "type": "paragraph",
            "text": "“Integration Interface” or “API”: Any optional technical integration between ZORY’s systems and the Merchant’s systems that enables product updates, interaction measurement, or tracking of certain user behaviors related to Products."
          },
          {
            "type": "paragraph",
            "text": "“Commercial Agreement”: Any agreement, commercial offer, subscription document, or written and signed contract between ZORY and the Merchant that governs the specific commercial terms between the parties."
          }
        ]
      },
      {
        "title": "Article 2 – Scope of the Relationship",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY’s relationship with the Merchant is limited to enabling the Merchant to list its Products within the Platform, and to use such Products within search, recommendation, design, smart replacement, and display systems for End Users, in exchange for an annual subscription."
          },
          {
            "type": "paragraph",
            "text": "These Terms do not create any agency, partnership, franchise, or commercial representation relationship between ZORY and the Merchant, and ZORY is not a seller, distributor, agent, or party responsible for selling the Merchant’s Products to End Users."
          },
          {
            "type": "paragraph",
            "text": "ZORY displays, suggests, or includes the Merchant’s Products within designs and Outputs when such Products match the design needs and the applicable algorithmic criteria within the Platform."
          },
          {
            "type": "paragraph",
            "text": "ZORY does not guarantee to the Merchant any specific number of visits, views, clicks, conversions, sales, or revenues."
          }
        ]
      },
      {
        "title": "Article 3 – ZORY’s Obligations",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Subject to the remaining provisions of these Terms and the nature of the service provided “as is”, ZORY undertakes to:"
          },
          {
            "type": "list",
            "items": [
              "Use reasonable care in operating the Platform and making it reasonably available. • Make the Dashboard reasonably available to the Merchant to manage its Products and monitor their performance, in accordance with the available technical capabilities. • Notify the Merchant, through the Platform or approved communication channels, before any material change made by ZORY that directly and materially affects the visibility of the Merchant’s Products, where reasonably and practically possible."
            ]
          },
          {
            "type": "paragraph",
            "text": "These obligations do not create any guarantee of commercial outcome, level of visibility, conversions, or sales, and remain subject to the disclaimers and limitations of warranty set out in these Terms."
          }
        ]
      },
      {
        "title": "Article 4 – Merchant Eligibility and Representations",
        "blocks": [
          {
            "type": "subtitle",
            "text": "Merchant Eligibility"
          },
          {
            "type": "paragraph",
            "text": "The Merchant must be a company or establishment legally existing and must have the legal authority to sell the Products it lists on the Platform."
          },
          {
            "type": "paragraph",
            "text": "The Merchant undertakes to provide accurate, complete, and up-to-date information upon registration or contracting, including entity details, contact information, billing details, and any other information reasonably requested by ZORY."
          },
          {
            "type": "paragraph",
            "text": "ZORY may refuse the Merchant’s registration, suspend its account, or terminate its onboarding if the information provided is found to be incorrect, misleading, or incomplete, or if the Merchant breaches these Terms or any Commercial Agreement signed with it."
          },
          {
            "type": "subtitle",
            "text": "Merchant Representations and Warranties"
          },
          {
            "type": "paragraph",
            "text": "The Merchant represents and warrants to ZORY, throughout the contractual relationship, that:"
          },
          {
            "type": "list",
            "items": [
              "It is a legally existing and licensed entity and has full legal authority to sell, display, and make available the Products it lists on the Platform. • It owns all rights to the Products, their data, images, descriptions, and trademarks, or has obtained the necessary licenses and permissions to use them and make them available to ZORY. • All Product Data, prices, descriptions, and specifications are correct, accurate, up to date, and not misleading. • Its Products are lawful, safe, and compliant with the applicable specifications and requirements in the Kingdom of Saudi Arabia. • Its use of the Platform and listing of Products do not violate any applicable law or third-party right. • The images and content it uploads do not include any personal data of any person, in line with the nature of the Platform, which is based on displaying furniture and décor products. The Merchant shall bear full responsibility if any images or content submitted by it include any personal data."
            ]
          },
          {
            "type": "paragraph",
            "text": "Any breach by the Merchant of any of these representations or warranties shall constitute a material breach of these Terms, entitling ZORY to suspend or terminate the account without refund, while reserving all of ZORY’s rights to seek recourse against the Merchant."
          }
        ]
      },
      {
        "title": "Article 5 – Annual Subscription and Payment",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant’s onboarding onto the ZORY Platform shall be in exchange for a fixed annual subscription. ZORY shall not be entitled to any commission on the Merchant’s sales or conversions generated through the Platform, unless otherwise agreed in writing in a separate Commercial Agreement."
          },
          {
            "type": "paragraph",
            "text": "The annual Subscription Fees, package, permitted number of Products, and any other commercial benefits shall be determined based on what is agreed in the Commercial Agreement signed between the parties, or as directly communicated by ZORY to the Merchant through the approved communication channels. Such commercial terms shall not be published publicly unless ZORY decides otherwise."
          },
          {
            "type": "paragraph",
            "text": "The annual Subscription Fees include Value Added Tax where applicable, unless otherwise stated in the Commercial Agreement or in the commercial notice issued by ZORY."
          },
          {
            "type": "paragraph",
            "text": "The annual subscription term begins from the date the Merchant pays the Subscription Fees, and the package benefits and Dashboard access are activated after payment."
          },
          {
            "type": "paragraph",
            "text": "The annual subscription is non-refundable after payment or activation, whether or not the Merchant uses the Platform, and whether or not its Products generate interactions, conversions, or sales."
          },
          {
            "type": "paragraph",
            "text": "ZORY does not provide a free trial period to the Merchant, unless otherwise agreed in writing."
          },
          {
            "type": "paragraph",
            "text": "The annual subscription renews automatically for a similar term unless the Merchant notifies ZORY of its desire not to renew at least thirty (30) days before the end of the subscription term."
          },
          {
            "type": "paragraph",
            "text": "ZORY may amend the Subscription Fees from time to time. If the renewal price changes, ZORY shall notify the Merchant through the Platform or through the approved communication channels before renewal. If the Merchant does not object or express its desire not to renew within the period specified in the notice, the subscription shall renew automatically at the new notified price."
          },
          {
            "type": "paragraph",
            "text": "If payment cannot be collected or the Merchant delays payment, ZORY has the right to suspend the visibility of the Merchant’s Products, restrict its access to the Dashboard, or terminate the subscription, without any refund or compensation resulting therefrom."
          },
          {
            "type": "paragraph",
            "text": "If the Merchant wishes to increase the number of its Products beyond the limit of its package during the subscription term, ZORY shall notify the Merchant of the additional fees due, and the ability to add Products on the Platform shall not be enabled until such fees are paid."
          }
        ]
      },
      {
        "title": "Article 6 – Dashboard and Product Management",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY provides the Merchant with a Dashboard that enables it, according to what the Platform makes available, to upload its Products, update their data, delete them, monitor their performance, and view related interaction, conversion, and analytics data."
          },
          {
            "type": "paragraph",
            "text": "The Merchant undertakes that the Products and data displayed in the Dashboard shall match the actual Products displayed on its website or official channels."
          },
          {
            "type": "paragraph",
            "text": "The Merchant alone is responsible for updating its Product Data, including prices, availability, inventory, images, dimensions, categories, descriptions, and product links."
          },
          {
            "type": "paragraph",
            "text": "ZORY shall not be liable for any error, omission, misleading information, or failure to update Product Data provided by the Merchant."
          },
          {
            "type": "paragraph",
            "text": "ZORY may conduct periodic quality checks on Product Data. If repeated violations, incorrect data, non-functional links, or non-compliant Products are found, ZORY has the right to suspend the Merchant’s account, stop the visibility of its Products, or terminate its subscription without refunding any amounts paid."
          }
        ]
      },
      {
        "title": "Article 7 – Product Data, Links, and Categories",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant undertakes to enter the mandatory data for each Product, including at minimum:"
          },
          {
            "type": "list",
            "items": [
              "Product name.",
              "Price.",
              "Currency.",
              "Dimensions.",
              "Category.",
              "Product link.",
              "Image links.",
              "Any additional data reasonably requested by ZORY to improve the Product’s visibility, readability, or analysis."
            ]
          },
          {
            "type": "paragraph",
            "text": "The listed Products must fall within ZORY’s approved furniture and décor categories, such as furniture, lighting, rugs, décor, curtains, mirrors, plants, home accessories, and any other categories approved by ZORY from time to time."
          },
          {
            "type": "paragraph",
            "text": "The Merchant is prohibited from listing any Products outside the scope of furniture and décor or outside ZORY’s approved categories."
          },
          {
            "type": "paragraph",
            "text": "The listed Products must be actually available for sale and present in the Merchant’s inventory, or available for supply by the Merchant at the time of display. The Merchant may not upload fake, unavailable, or misleading Products."
          },
          {
            "type": "paragraph",
            "text": "Products may not be uploaded without a price, and customized or made-to-order Products may not be uploaded unless ZORY expressly agrees to this in writing."
          },
          {
            "type": "paragraph",
            "text": "The Merchant undertakes to provide real, active, and direct links for each Product, so that the End User is directed to the actual product page on the Merchant’s website."
          },
          {
            "type": "paragraph",
            "text": "If the links are broken, incorrect, misleading, or do not lead to the actual product page, ZORY has the right to delete, freeze, suspend the visibility of the Product, or take any appropriate action without prior notice."
          }
        ]
      },
      {
        "title": "Article 8 – Quality of Product Data and Images",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant undertakes to provide data and images of sufficient quality to enable ZORY’s systems to read, analyze, understand, and use the Product within designs and recommendations."
          },
          {
            "type": "paragraph",
            "text": "Product images should preferably be high quality, clear, not blurred, and show the Product in a manner that allows the artificial intelligence to analyze its color, shape, style, dimensions, and potential use within the design."
          },
          {
            "type": "paragraph",
            "text": "The Merchant understands that poor data or image quality may negatively affect the Product’s visibility, ranking, or ability to match within designs and Outputs, and ZORY shall not be liable for weak Product visibility resulting from incomplete or poor-quality data."
          },
          {
            "type": "paragraph",
            "text": "ZORY may set additional technical requirements or quality guidelines for Product Data, images, or links, and the Merchant shall comply with them within the period specified by ZORY."
          }
        ]
      },
      {
        "title": "Article 9 – License to Use Products and Content",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Upon uploading Products, their data, or images to ZORY, the Merchant grants ZORY a worldwide, non-exclusive license, usable throughout the subscription term and after its expiry to the extent technically and operationally necessary, to use Product Data, images, links, descriptions, trademarks, and any related content within the Platform."
          },
          {
            "type": "paragraph",
            "text": "This license includes ZORY’s right to use the Products, their data, and images for the following purposes:"
          },
          {
            "type": "list",
            "items": [
              "Displaying Products to End Users.",
              "Including Products within designs and Outputs.",
              "Product search.",
              "Product recommendation.",
              "Smart product replacement.",
              "Two-dimensional and three-dimensional designs.",
              "Training artificial intelligence models.",
              "Improving algorithms and recommendation systems.",
              "Analyzing Product performance and interaction.",
              "Operating and improving the Platform and its services."
            ]
          },
          {
            "type": "paragraph",
            "text": "The Merchant acknowledges that the license granted to ZORY does not expire with respect to data, images, characteristics, patterns, or information used to train or improve artificial intelligence systems or algorithms, to the extent that they cannot be technically separated from the models or systems that have been developed."
          },
          {
            "type": "paragraph",
            "text": "The Merchant has the right to request the deletion of its Products from the Platform interface after the end of the subscription. Such deletion shall result in removing the Products from active display and the Platform’s operational systems according to the available technical capabilities, without affecting any models, algorithms, training outputs, anonymized data, or aggregated data previously used to improve ZORY’s systems."
          }
        ]
      },
      {
        "title": "Article 10 – Use of Products in Artificial Intelligence and Designs",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant understands and agrees that its Products may be used within ZORY in:"
          },
          {
            "type": "list",
            "items": [
              "Designs created by End Users.",
              "Smart suggestions inside rooms and spaces.",
              "Product search results.",
              "Replacing Products within a design with similar Products.",
              "Three-dimensional designs.",
              "Two-dimensional designs.",
              "Furniture and décor recommendations.",
              "Improving the End User experience.",
              "Training and improving artificial intelligence models and algorithms."
            ]
          },
          {
            "type": "paragraph",
            "text": "ZORY may technically process Product images, including background removal, quality enhancement, color analysis, shape analysis, converting the Product into a digital element within the design, or generating a three-dimensional or semi-three-dimensional version of it, for the purposes of operating the Platform and improving the display of the Product within designs."
          },
          {
            "type": "paragraph",
            "text": "ZORY does not guarantee that the Product will appear in every design, search result, or recommendation, nor does it guarantee that it will be used or selected by the End User."
          }
        ]
      },
      {
        "title": "Article 11 – Visibility, Ranking, and Replacement Algorithms",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The visibility and ranking of the Merchant’s Products within ZORY depend on the Platform’s algorithms and the matching and analysis criteria adopted by ZORY from time to time."
          },
          {
            "type": "paragraph",
            "text": "Visibility and ranking factors include, without limitation:"
          },
          {
            "type": "list",
            "items": [
              "Color.",
              "Shape.",
              "Measurements.",
              "Product type.",
              "Design style.",
              "Availability.",
              "Quality of Product Data.",
              "Quality of images.",
              "Product suitability for the design.",
              "The degree of match between the Product and the item within the design.",
              "Product performance and user interactions with it.",
              "Any other technical or operational factors determined by ZORY."
            ]
          },
          {
            "type": "paragraph",
            "text": "If the Merchant’s Product matches the product or item required within the design, it may be displayed at the beginning of the results or among advanced results depending on the degree of matching."
          },
          {
            "type": "paragraph",
            "text": "If another Product from another Merchant is more compatible in terms of color, shape, style, measurements, or design suitability, ZORY’s algorithms may display that Product before the Merchant’s Product."
          },
          {
            "type": "paragraph",
            "text": "The Merchant understands that this is how ZORY’s algorithms operate, and that subscribing to the Platform does not grant the Merchant any guaranteed right to first visibility, higher ranking, or absolute priority."
          },
          {
            "type": "paragraph",
            "text": "ZORY may change, modify, or improve visibility, ranking, and replacement algorithms at any time without prior notice, without this giving rise to any right for the Merchant to object, claim compensation, or request a refund."
          },
          {
            "type": "paragraph",
            "text": "ZORY may offer additional packages or benefits that provide visibility priority or enhanced display opportunities; however, such priority remains subject to algorithmic matching criteria and Product suitability for the design, and does not mean displaying an unsuitable or non-matching Product before a Product that is more suitable for the design."
          }
        ]
      },
      {
        "title": "Article 12 – Analytics, Interaction, and Conversion",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY provides the Merchant, depending on the package, integration method, or available technical capabilities, with data and analytics through the Dashboard relating to End Users’ interaction with its Products."
          },
          {
            "type": "paragraph",
            "text": "Analytics may include, depending on what the Platform makes available:"
          },
          {
            "type": "list",
            "items": [
              "Product views.",
              "Product clicks.",
              "Conversion to the product page on the Merchant’s website.",
              "Performance by day.",
              "Most interacted-with Products.",
              "User behavior related to Products within the Platform.",
              "Any additional indicators provided by ZORY from time to time."
            ]
          },
          {
            "type": "paragraph",
            "text": "For the purposes of these Terms, Conversion means the transfer of the End User from the ZORY Platform to the product page on the Merchant’s website."
          },
          {
            "type": "paragraph",
            "text": "If the Merchant uploads its Products directly through ZORY without technical integration, ZORY measures the conversions and interactions available within or through the Platform."
          },
          {
            "type": "paragraph",
            "text": "If integration through an API or any approved tracking mechanism is implemented, ZORY may be able to measure visits to the product page on the Merchant’s website and track certain behaviors related to the Product, such as viewing the Product, clicking, adding to cart, completing a purchase, or order value, depending on what is permitted by the technical integration and available data."
          },
          {
            "type": "paragraph",
            "text": "The analytics displayed in the Dashboard are direct and reflect behavior by day and according to the data available to ZORY."
          },
          {
            "type": "paragraph",
            "text": "Although ZORY uses reasonable efforts to provide accurate analytics, any figures, reports, or performance indicators may be affected by technical factors, external integrations, tracking tools, browser settings, or the Merchant’s website, and do not constitute a guarantee of any commercial outcome."
          }
        ]
      },
      {
        "title": "Article 13 – Technical Integration and APIs",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Integration through an API is optional and is not a basic requirement for the Merchant’s use of the Platform, unless otherwise agreed in writing."
          },
          {
            "type": "paragraph",
            "text": "If the Merchant chooses API integration, it shall be responsible for the technical and operational costs related to integration and maintenance on its side, including the readiness of its systems, data accuracy, security of integration keys, and continuity of links."
          },
          {
            "type": "paragraph",
            "text": "In the case of API integration, the Merchant grants ZORY the right to access the data available through the integration and related to Product performance and associated user behavior, including product views, clicks, adding to cart, completing purchases, and order value, according to what the Merchant’s systems and the agreed integration make available."
          },
          {
            "type": "paragraph",
            "text": "ZORY does not collect End User data from the Merchant’s website except within the limits of referral link tracking or the technical data necessary to measure conversions and interaction, unless otherwise agreed in writing and in compliance with applicable laws."
          },
          {
            "type": "paragraph",
            "text": "If the technical integration fails or the API connection cannot be established, the parties shall seek to resolve the issue, and the transfer of the End User to the product page on the Merchant’s website shall remain in place whenever the link is available and functioning properly."
          },
          {
            "type": "paragraph",
            "text": "ZORY shall not be liable for the failure of the Merchant’s systems, its API, links, or data provided by it, nor for any shortage or interruption in analytics resulting from the same."
          }
        ]
      },
      {
        "title": "Article 14 – No Guarantee of Sales or Conversions",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant understands that the benefit of the Platform lies in enabling End Users to interact with its Products, view such Products within designs, and move to the product page on the Merchant’s website whenever the Product is suitable and matches the design need."
          },
          {
            "type": "paragraph",
            "text": "ZORY does not guarantee any sales, revenues, number of visits, number of clicks, number of conversions, or any specific conversion rate."
          },
          {
            "type": "paragraph",
            "text": "The appearance of a Product within a design, search results, smart replacement, or recommendation panel shall not be considered a promise by ZORY to achieve a sale, order, profit, or commercial return."
          },
          {
            "type": "paragraph",
            "text": "The Merchant alone is responsible for converting visits into sales on its website or channels, including the user experience on its website, prices, inventory, payment, shipping, customer service, and return and replacement policies."
          }
        ]
      },
      {
        "title": "Article 15 – Merchant Responsibilities Toward the End User",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Purchases do not take place within ZORY. Instead, the End User is redirected to the product page on the Merchant’s website or official channels."
          },
          {
            "type": "paragraph",
            "text": "ZORY is not a party to any purchase made between the End User and the Merchant and bears no responsibility for price, availability, payment, shipping, delivery, installation, returns, replacement, warranty, product quality, or any claim arising between the End User and the Merchant."
          },
          {
            "type": "paragraph",
            "text": "The Merchant alone is responsible for the accuracy of prices, product availability, terms of sale, order fulfillment, payment processing, customer service, shipping, delivery, returns, replacement, warranty, and any legal or commercial obligations toward the End User."
          },
          {
            "type": "paragraph",
            "text": "If the End User purchases a Product from the Merchant’s website and any issue, dispute, or claim arises, the relationship shall be directly between the End User and the Merchant, and ZORY shall be entirely outside that relationship."
          }
        ]
      },
      {
        "title": "Article 16 – Intellectual Property and Product and Image Rights",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant alone shall be responsible for any infringement or violation relating to intellectual property, trademarks, image rights, product descriptions, or any content uploaded by it to ZORY."
          },
          {
            "type": "paragraph",
            "text": "ZORY shall not be liable for any claim, dispute, damage, or loss arising from the Merchant’s use of images, descriptions, marks, or Product Data that it does not have the right to use or does not have the legal authority to display."
          },
          {
            "type": "paragraph",
            "text": "ZORY has the right to use the Merchant’s name, logo, and trademark within the Platform, in commercial presentations, marketing materials, partner lists, and any informational materials related to the Platform, without the need for separate consent, unless otherwise agreed in writing."
          },
          {
            "type": "paragraph",
            "text": "The ZORY Platform, its algorithms, models, systems, interfaces, designs, software, display methods, recommendation systems, ranking systems, and replacement systems shall remain owned by or licensed to ZORY, and no intellectual property rights therein shall be transferred to the Merchant under these Terms."
          }
        ]
      },
      {
        "title": "Article 17 – Prohibited Products and Infringing Content",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant is prohibited from uploading or listing any Products outside ZORY’s approved furniture and décor categories."
          },
          {
            "type": "paragraph",
            "text": "The Merchant is also prohibited from uploading or listing any Product or content that:"
          },
          {
            "type": "list",
            "items": [
              "Violates applicable laws.",
              "Is counterfeit or infringes the rights of others.",
              "Is misleading or incorrect.",
              "Is not actually available for sale.",
              "Contains unreal or non-functional links.",
              "Falls outside ZORY’s categories.",
              "Offends users or violates public morals.",
              "May harm ZORY’s reputation or the End User experience."
            ]
          },
          {
            "type": "paragraph",
            "text": "ZORY has the right to immediately delete, freeze, or restrict any infringing Product without prior notice, whether or not the Merchant’s account is terminated."
          },
          {
            "type": "paragraph",
            "text": "ZORY may freeze certain Products until they are verified, until the artificial intelligence systems complete training on them, or until their reading and analysis are improved."
          }
        ]
      },
      {
        "title": "Article 18 – Non-Circumvention and Non-Competition",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant may not use the Platform, Dashboard, or any data, analytics, or mechanisms obtained from ZORY for the purpose of building, developing, supporting, or operating a service or platform competing with ZORY, or for copying its algorithms, systems, or display methods."
          },
          {
            "type": "paragraph",
            "text": "The Merchant may not attempt to circumvent the Platform or its technical or commercial mechanisms for the purpose of exploiting its data or its relationship with End Users outside the scope authorized under these Terms."
          }
        ]
      },
      {
        "title": "Article 19 – Suspension, Deletion, and Termination",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY may suspend the Merchant’s account, restrict its access, delete or freeze its Products, or terminate its subscription immediately and without refund in any of the following cases:"
          },
          {
            "type": "list",
            "items": [
              "Failure to pay the Subscription Fees.",
              "Broken, misleading, or unreal links.",
              "Providing incorrect or misleading Product Data.",
              "Uploading Products outside the approved categories.",
              "Repeated complaints from End Users.",
              "Violation of intellectual property rights, privacy, or laws.",
              "Misuse of the Dashboard or the Platform.",
              "Attempting to manipulate algorithms or analytics.",
              "Introducing harmful data, files, or code.",
              "Breach of these Terms or the Commercial Agreement."
            ]
          },
          {
            "type": "paragraph",
            "text": "ZORY may immediately delete or freeze infringing Products without granting a correction period whenever it deems this necessary to protect the Platform, users, service quality, or legal compliance."
          },
          {
            "type": "paragraph",
            "text": "Suspension, deletion, or termination due to the Merchant’s breach shall not give rise to any right to refund Subscription Fees or claim compensation."
          },
          {
            "type": "paragraph",
            "text": "Upon termination of the subscription for any reason, the Merchant shall continue to have access to the Dashboard for one (1) month from the termination date for the purpose of reviewing and downloading its data. After this period expires, access to the Dashboard shall be permanently stopped. ZORY’s retention of any data for legal, accounting, tax, or security purposes shall remain subject to applicable laws."
          }
        ]
      },
      {
        "title": "Article 20 – Signed Agreements",
        "blocks": [
          {
            "type": "paragraph",
            "text": "If there is a Commercial Agreement signed between ZORY and the Merchant, it shall be complementary to these Terms."
          },
          {
            "type": "paragraph",
            "text": "In the event of a conflict between these Terms and the signed Commercial Agreement, the Commercial Agreement shall prevail with respect to specific commercial terms, such as fees, package, subscription term, number of Products, display benefits, or any special commercial benefits agreed in writing."
          },
          {
            "type": "paragraph",
            "text": "As for general, operational, technical, and legal provisions relating to the use of the Platform, Dashboard, algorithms, data, responsibilities, warranty limitations, suspension, and termination, these Terms shall remain applicable unless the Commercial Agreement expressly provides otherwise."
          }
        ]
      },
      {
        "title": "Article 21 – Confidentiality and Data",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Each party shall maintain the confidentiality of non-public information obtained from the other party in connection with the commercial relationship, including commercial and technical information, unpublished prices, performance data, and any information described as confidential or logically presumed to be confidential."
          },
          {
            "type": "paragraph",
            "text": "The Merchant may not use any data or information obtained from the Dashboard or the Platform except for the purposes of monitoring the performance of its Products within ZORY and improving their data and experience."
          },
          {
            "type": "paragraph",
            "text": "ZORY may use Product Data, interaction, conversion, and analytics data for the purposes of operating the Platform, improving algorithms, product development, preparing reports, measuring performance, and improving the End User experience, including the use of anonymized or aggregated data."
          },
          {
            "type": "paragraph",
            "text": "The Merchant may not attempt to access data relating to other merchants, End Users, ZORY’s systems, or any data it is not authorized to access."
          }
        ]
      },
      {
        "title": "Article 22 – Data Protection",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY undertakes to use reasonable care to protect the data it processes in the course of operating the Platform and to apply appropriate technical and organizational measures to maintain its security."
          },
          {
            "type": "paragraph",
            "text": "The Merchant acknowledges that the ZORY Platform is based on displaying furniture and décor products, and the Merchant undertakes that the images, data, or content it uploads shall not include any personal data of any person. The Merchant alone shall bear full legal responsibility if the content submitted by it includes any personal data, and shall release ZORY from any claim or damage arising therefrom."
          }
        ]
      },
      {
        "title": "Article 23 – Disclaimer of Liability and Limitation of Warranty",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY provides its services, Dashboard, algorithms, analytics, and display tools “as is” and “as available”, without any warranty that the Merchant’s Products will appear in a particular ranking or achieve conversions, sales, or specific commercial results."
          },
          {
            "type": "paragraph",
            "text": "ZORY does not warrant that the algorithms, analytics, or interaction data will be error-free, permanently available, or suitable for a particular commercial purpose of the Merchant."
          },
          {
            "type": "paragraph",
            "text": "ZORY shall not be liable for any direct, indirect, or consequential loss, loss of profits, loss of commercial opportunities, decline in sales, or poor commercial performance resulting from the Merchant’s use of the Platform or reliance on analytics, algorithms, or visibility results."
          },
          {
            "type": "paragraph",
            "text": "ZORY shall not be liable for the Merchant’s Products, content, links, website, sales process, or relationship with the End User."
          },
          {
            "type": "paragraph",
            "text": "To the maximum extent permitted by law, ZORY’s maximum liability, if any and if established by a final judgment, shall be limited to the amounts paid by the Merchant to ZORY for the most recent annual subscription term, and shall not include any indirect or consequential damages, loss of profits, or loss of opportunities."
          }
        ]
      },
      {
        "title": "Article 24 – Indemnification",
        "blocks": [
          {
            "type": "paragraph",
            "text": "The Merchant undertakes to defend, indemnify, and hold harmless ZORY, its company, owners, directors, employees, and service providers from and against any claims, lawsuits, damages, losses, fines, costs, or expenses, including reasonable legal fees, arising out of or relating to any of the following:"
          },
          {
            "type": "list",
            "items": [
              "The Merchant’s breach of these Terms or any representation or warranty contained herein. • The Merchant’s Products, their data, images, descriptions, trademarks, or links. • The Merchant’s violation of intellectual property rights, third-party rights, or applicable laws. • The Merchant’s relationship with the End User, including sale, supply, shipping, returns, warranty, and customer service. • The content submitted by the Merchant containing any personal data. • Any unauthorized access resulting from the Merchant’s negligence or sharing of login credentials."
            ]
          }
        ]
      },
      {
        "title": "Article 25 – Force Majeure",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY shall not be liable for any delay, failure, interruption, or poor performance resulting from events beyond its reasonable control, including internet outages, cloud service provider failures, artificial intelligence provider failures, payment gateway failures, cyberattacks, natural disasters, government actions, or any other force majeure circumstances."
          }
        ]
      },
      {
        "title": "Article 26 – Notices and Official Communication Channels",
        "blocks": [
          {
            "type": "paragraph",
            "text": "ZORY may send notices to the Merchant through the Platform, Dashboard, email, website, or any approved communication channel. The Merchant is responsible for keeping its contact information accurate and up to date."
          },
          {
            "type": "paragraph",
            "text": "All notices, requests, and official contractual correspondence shall be submitted through the approved official channel: support@zory.ai."
          }
        ]
      },
      {
        "title": "Article 27 – Governing Law and Dispute Resolution",
        "blocks": [
          {
            "type": "paragraph",
            "text": "These Terms shall be governed by and interpreted in accordance with the laws of the Kingdom of Saudi Arabia."
          },
          {
            "type": "paragraph",
            "text": "The parties shall first seek to resolve any dispute arising from these Terms or the commercial relationship between them amicably within thirty (30) calendar days from the date one party notifies the other party of the dispute."
          },
          {
            "type": "paragraph",
            "text": "If the dispute cannot be resolved amicably within that period, the competent courts in the Kingdom of Saudi Arabia shall have jurisdiction to hear the dispute, unless a signed Commercial Agreement provides otherwise in a manner that does not violate applicable laws."
          }
        ]
      },
      {
        "title": "Article 28 – General Provisions",
        "blocks": [
          {
            "type": "paragraph",
            "text": "These Terms, together with any signed Commercial Agreement and referenced policies, constitute the framework governing the Merchant’s relationship with ZORY in relation to listing and using Products within the Platform."
          },
          {
            "type": "paragraph",
            "text": "If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain valid and enforceable, and the invalid or unenforceable provision shall be replaced with a lawful provision that achieves the original commercial intent as closely as possible."
          },
          {
            "type": "paragraph",
            "text": "ZORY’s failure to exercise any right under these Terms shall not constitute a waiver of such right."
          },
          {
            "type": "paragraph",
            "text": "The Merchant may not assign its rights or obligations under these Terms without ZORY’s prior written consent, while ZORY may assign or transfer them as part of any restructuring, merger, acquisition, or transfer of business."
          },
          {
            "type": "paragraph",
            "text": "ZORY may amend these Terms from time to time, and the updated version shall be published through the Platform, website, or Dashboard, or sent to the Merchant through the approved communication channels. The Merchant’s continued use of the Platform after the updates become effective shall constitute acceptance of the amended Terms."
          },
          {
            "type": "paragraph",
            "text": "The Arabic version is the official and controlling version of these Terms. If an English version or any other translation is prepared, it shall be for convenience purposes only, and the Arabic version shall prevail in the event of any conflict."
          }
        ]
      }
    ]
  },
  "ar": {
    "title": "شروط وأحكام التحاق التجار بمنصة زوري",
    "subtitle": "",
    "intro": [
      "تحكم هذه الشروط والأحكام (“الشروط”) علاقة التاجر بمنصة زوري، وذلك فيما يتعلق بالتحاقه بالمنصة، ورفع منتجاته، وإدارتها، وإتاحتها للاستخدام ضمن أدوات التصميم بالذكاء الاصطناعي، والبحث عن المنتجات، والاستبدال الذكي، والتصاميم ثنائية وثلاثية الأبعاد، وأي خدمات أو أدوات أو لوحات تحكم مرتبطة بذلك.",
      "منصة زوري (“زوري” أو “المنصة”) مملوكة ومشغلة من قبل شركة بروسبرتي اورا (“الشركة” أو “نحن”). وتوفر زوري للتجار إمكانية عرض منتجات الأثاث والديكور داخل المنصة، بحيث يمكن استخدامها أو اقتراحها أو عرضها للمستخدمين النهائيين ضمن التصاميم والمخرجات التي تولدها أو تدعمها أنظمة الذكاء الاصطناعي في زوري.",
      "بانضمامك إلى المنصة بصفتك تاجرًا، أو بتوقيعك اتفاقية تجارية مع زوري، أو بسدادك رسوم الاشتراك، أو باستخدامك لوحة التحكم، أو برفعك أي منتجات أو بيانات أو صور إلى المنصة، فإنك تقر بأنك قرأت هذه الشروط وفهمتها ووافقت على الالتزام بها.",
      "إذا كنت تمثل شركة أو مؤسسة أو جهة اعتبارية، فإنك تقر بأنك مفوض نظامًا بإلزام تلك الجهة بهذه الشروط، ويشمل مصطلح “التاجر” تلك الجهة.",
      "في حال عدم موافقتك على هذه الشروط، يجب عليك عدم استخدام المنصة أو رفع أي منتجات إليها."
    ],
    "sections": [
      {
        "title": "المادة 1 – التعريفات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "لأغراض هذه الشروط، تكون للمصطلحات التالية المعاني المبينة أمام كل منها، ما لم يقتض السياق خلاف ذلك:"
          },
          {
            "type": "paragraph",
            "text": "“زوري” أو “المنصة”: منصة زوري الرقمية، بما في ذلك الموقع الإلكتروني، التطبيقات، لوحة التحكم، أدوات التصميم بالذكاء الاصطناعي، أدوات البحث عن المنتجات، أدوات الاستبدال الذكي، أدوات التصاميم ثلاثية الأبعاد، الأنظمة الخلفية، واجهات الربط، وأي خدمات مرتبطة بها."
          },
          {
            "type": "paragraph",
            "text": "“الشركة”: شركة بروسبرتي اورا، المالكة والمشغلة لمنصة زوري."
          },
          {
            "type": "paragraph",
            "text": "“التاجر”: أي شركة أو مؤسسة تنضم إلى منصة زوري لرفع منتجاتها وإتاحتها داخل المنصة مقابل اشتراك سنوي."
          },
          {
            "type": "paragraph",
            "text": "“المنتجات”: منتجات الأثاث والديكور التي يرفعها التاجر إلى المنصة أو يتيحها من خلال الربط التقني، بما في ذلك الصور، الأوصاف، الأسعار، الأبعاد، التصنيفات، الروابط، وأي بيانات أخرى مرتبطة بها."
          },
          {
            "type": "paragraph",
            "text": "“بيانات المنتج”: جميع المعلومات المتعلقة بالمنتج، بما في ذلك اسم المنتج، السعر، العملة، الأبعاد، التصنيف، رابط المنتج، روابط الصور، الوصف، حالة التوفر، وأي بيانات فنية أو تجارية أو وصفية أخرى."
          },
          {
            "type": "paragraph",
            "text": "“لوحة التحكم”: الواجهة التي توفرها زوري للتاجر لإدارة منتجاته، وتحديثها، وحذفها، ومتابعة أدائها، والاطلاع على بيانات التفاعل والتحويل والتحليلات المتاحة."
          },
          {
            "type": "paragraph",
            "text": "“المستخدم النهائي”: أي شخص يستخدم منصة زوري لتصميم المساحات الداخلية، أو البحث عن المنتجات، أو استعراض التصاميم، أو الانتقال إلى منتجات التاجر."
          },
          {
            "type": "paragraph",
            "text": "“المخرجات”: أي تصميم أو تصور أو صورة أو توصية أو ترتيب أثاث أو نتيجة بحث أو نتيجة استبدال أو تصميم ثنائي أو ثلاثي الأبعاد يظهر من خلال المنصة."
          },
          {
            "type": "paragraph",
            "text": "“الذكاء الاصطناعي”: أنظمة زوري وخوارزمياتها ونماذجها وأدواتها التقنية المستخدمة في تحليل المنتجات، وتوليد التصاميم، وتقديم التوصيات، واستبدال المنتجات، وترتيب الظهور، وتحسين تجربة المستخدم."
          },
          {
            "type": "paragraph",
            "text": "“التحويل”: انتقال المستخدم النهائي من منصة زوري إلى صفحة المنتج في موقع التاجر من خلال الرابط المخصص لذلك، أو أي تفاعل آخر يتم قياسه من خلال لوحة التحكم أو الربط التقني حيثما ينطبق."
          },
          {
            "type": "paragraph",
            "text": "“واجهة الربط” أو “API”: أي ربط تقني اختياري بين أنظمة زوري وأنظمة التاجر يتيح تحديث المنتجات أو قياس التفاعل أو تتبع بعض سلوكيات المستخدم المتعلقة بالمنتجات."
          },
          {
            "type": "paragraph",
            "text": "“الاتفاقية التجارية”: أي اتفاقية أو عرض تجاري أو مستند اشتراك أو عقد مكتوب وموقع بين زوري والتاجر ينظم الأحكام التجارية الخاصة بين الطرفين."
          }
        ]
      },
      {
        "title": "المادة 2 – نطاق العلاقة",
        "blocks": [
          {
            "type": "paragraph",
            "text": "تنحصر علاقة زوري بالتاجر في تمكين التاجر من إدراج منتجاته داخل المنصة، واستخدام تلك المنتجات ضمن أنظمة البحث والتوصية والتصميم والاستبدال الذكي والعرض للمستخدمين النهائيين، وذلك مقابل اشتراك سنوي."
          },
          {
            "type": "paragraph",
            "text": "لا تنشئ هذه الشروط أي علاقة وكالة أو شراكة أو امتياز أو تمثيل تجاري بين زوري والتاجر، ولا تعد زوري بائعة أو موزعة أو وكيلة أو مسؤولة عن بيع منتجات التاجر للمستخدمين النهائيين."
          },
          {
            "type": "paragraph",
            "text": "تقوم زوري بعرض منتجات التاجر أو اقتراحها أو تضمينها ضمن التصاميم والمخرجات متى ما تطابقت مع احتياجات التصميم ومعايير الخوارزميات المعمول بها في المنصة."
          },
          {
            "type": "paragraph",
            "text": "لا تضمن زوري للتاجر أي عدد محدد من الزيارات أو المشاهدات أو النقرات أو التحويلات أو المبيعات أو الإيرادات."
          }
        ]
      },
      {
        "title": "المادة 3 – التزامات زوري",
        "blocks": [
          {
            "type": "paragraph",
            "text": "مع مراعاة بقيّة أحكام هذه الشروط وطبيعة الخدمة المقدّمة \"كما هي\"، تلتزم زوري بما يلي:"
          },
          {
            "type": "list",
            "items": [
              "بذل عناية معقولة في تشغيل المنصّة وإتاحتها بصورة معقولة.",
              "إتاحة لوحة التحكم للتاجر بصورة معقولة لإدارة منتجاته ومتابعة أدائها، وفق الإمكانات الفنية المتاحة.",
              "إخطار التاجر، عبر المنصّة أو قنوات التواصل المعتمدة، قبل أي تغيير جوهري تُجريه زوري ويؤثّر بصورة مباشرة وجوهرية على ظهور منتجات التاجر، وذلك حيثما كان ذلك عمليًا ومعقولًا."
            ]
          },
          {
            "type": "paragraph",
            "text": "لا تُنشئ هذه الالتزامات أي ضمان بنتيجة تجارية أو بمستوى ظهور أو تحويلات أو مبيعات، وتظل خاضعة لأحكام إخلاء المسؤولية وحدود الضمان الواردة في هذه الشروط."
          }
        ]
      },
      {
        "title": "المادة 4 – أهلية التاجر والإقرارات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "أهلية التاجر:"
          },
          {
            "type": "paragraph",
            "text": "يجب أن يكون التاجر شركة أو مؤسسة قائمة بصورة نظامية، وأن يكون لديه الصلاحية النظامية لبيع المنتجات التي يدرجها في المنصة."
          },
          {
            "type": "paragraph",
            "text": "يلتزم التاجر بتقديم بيانات صحيحة وكاملة ومحدثة عند التسجيل أو التعاقد، بما في ذلك بيانات الكيان، معلومات التواصل، بيانات الفوترة، وأي معلومات أخرى تطلبها زوري بصورة معقولة."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري رفض تسجيل التاجر أو تعليق حسابه أو إنهاء التحاقه إذا تبين أن البيانات المقدمة غير صحيحة أو مضللة أو ناقصة، أو إذا خالف التاجر هذه الشروط أو أي اتفاقية تجارية موقعة معه."
          },
          {
            "type": "paragraph",
            "text": "إقرارات التاجر وضماناته:"
          },
          {
            "type": "paragraph",
            "text": "يقرّ التاجر ويضمن لزوري، طوال مدّة العلاقة التعاقدية، بما يلي:"
          },
          {
            "type": "list",
            "items": [
              "أنه كيان قائم ومرخّص نظامًا، ويملك كامل الصلاحية النظامية لبيع المنتجات التي يدرجها وعرضها وإتاحتها في المنصّة.",
              "أنه يملك كامل الحقوق على المنتجات وبياناتها وصورها وأوصافها وعلاماتها التجارية، أو أنه حاصل على التراخيص والأذونات اللازمة لاستخدامها وإتاحتها لزوري.",
              "أن جميع بيانات المنتجات وأسعارها وأوصافها ومواصفاتها صحيحة ودقيقة ومحدّثة وغير مضلّلة.",
              "أن منتجاته نظامية وآمنة ومطابقة للمواصفات والمتطلبات المعمول بها في المملكة العربية السعودية.",
              "أن استخدامه للمنصّة وإدراجه للمنتجات لا يخالف أي نظام معمول به أو حق لطرف ثالث.",
              "أن الصور والمحتوى الذي يرفعه لا يتضمّن أي بيانات شخصية لأي شخص، بما يتوافق مع طبيعة المنصّة القائمة على عرض منتجات الأثاث والديكور. ويتحمّل التاجر وحده كامل المسؤولية في حال تضمّنت الصور أو المحتوى المقدَّم منه أي بيانات شخصية."
            ]
          },
          {
            "type": "paragraph",
            "text": "يُعدّ إخلال التاجر بأي من هذه الإقرارات أو الضمانات إخلالًا جوهريًا بهذه الشروط يخوّل زوري تعليق الحساب أو إنهاءه دون استرداد، مع احتفاظ زوري بكامل حقوقها في الرجوع على التاجر."
          }
        ]
      },
      {
        "title": "المادة 5 – الاشتراك السنوي والدفع",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يكون التحاق التاجر بمنصة زوري مقابل اشتراك سنوي ثابت، ولا تستحق زوري أي عمولة على مبيعات التاجر أو التحويلات الناتجة عن المنصة، ما لم يتم الاتفاق كتابةً على خلاف ذلك في اتفاقية تجارية مستقلة."
          },
          {
            "type": "paragraph",
            "text": "تُحدَّد رسوم الاشتراك السنوي والباقة وعدد المنتجات المسموح بها وأي مزايا تجارية أخرى بناءً على ما يتم الاتفاق عليه في الاتفاقية التجارية الموقّعة بين الطرفين، أو وفق ما تبلّغ به زوري التاجر مباشرةً عبر قنوات التواصل المعتمدة. ولا تُنشَر هذه الأحكام التجارية بصورة علنية ما لم تقرر زوري خلاف ذلك."
          },
          {
            "type": "paragraph",
            "text": "رسوم الاشتراك السنوي شاملة لضريبة القيمة المضافة حيثما تنطبق، ما لم يتم النص على خلاف ذلك في الاتفاقية التجارية أو في الإخطار التجاري الصادر من زوري."
          },
          {
            "type": "paragraph",
            "text": "تبدأ مدّة الاشتراك السنوي من تاريخ سداد التاجر لرسوم الاشتراك، وتُفعَّل مزايا الباقة والوصول إلى لوحة التحكم بعد السداد."
          },
          {
            "type": "paragraph",
            "text": "يكون الاشتراك السنوي غير قابل للاسترداد بعد السداد أو التفعيل، سواء استخدم التاجر المنصة أو لم يستخدمها، وسواء حققت منتجاته تفاعلًا أو تحويلات أو مبيعات أو لم تحقق."
          },
          {
            "type": "paragraph",
            "text": "لا توفر زوري فترة تجربة مجانية للتاجر، ما لم يتم الاتفاق كتابةً على خلاف ذلك."
          },
          {
            "type": "paragraph",
            "text": "يتجدد الاشتراك السنوي تلقائيًا لمدة مماثلة، ما لم يقم التاجر بإخطار زوري برغبته في عدم التجديد قبل ثلاثين (30) يومًا على الأقل من تاريخ انتهاء مدة الاشتراك."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري تعديل رسوم الاشتراك من وقت لآخر. وفي حال تغيّر سعر التجديد، تُبلِّغ زوري التاجر بذلك عبر المنصة أو عبر قنوات التواصل المعتمدة قبل التجديد. وإذا لم يُبدِ التاجر اعتراضه أو رغبته في عدم التجديد خلال المدة المحددة في الإخطار، يتجدد الاشتراك تلقائيًا على السعر الجديد المُبلَّغ به."
          },
          {
            "type": "paragraph",
            "text": "إذا تعذر تحصيل الدفعة أو تأخر التاجر في السداد، يحق لزوري تعليق ظهور منتجات التاجر أو تقييد وصوله إلى لوحة التحكم أو إنهاء الاشتراك، دون أن يترتب على ذلك أي استرداد أو تعويض."
          },
          {
            "type": "paragraph",
            "text": "إذا رغب التاجر في رفع عدد منتجاته بما يتجاوز حدّ باقته خلال مدة الاشتراك، تُبلِغه زوري بالرسوم الإضافية المستحقة، ولا تُفتح إمكانية الإضافة في المنصة إلا بعد سداد تلك الرسوم."
          }
        ]
      },
      {
        "title": "المادة 6 – لوحة التحكم وإدارة المنتجات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "توفر زوري للتاجر لوحة تحكم تمكنه، بحسب ما تتيحه المنصة، من رفع منتجاته، وتحديث بياناتها، وحذفها، ومتابعة أدائها، والاطلاع على التفاعل والتحويلات والتحليلات المرتبطة بها."
          },
          {
            "type": "paragraph",
            "text": "يلتزم التاجر بأن تكون المنتجات والبيانات المعروضة في لوحة التحكم مطابقة للمنتجات الفعلية المعروضة في موقعه أو قنواته الرسمية."
          },
          {
            "type": "paragraph",
            "text": "يتحمل التاجر وحده مسؤولية تحديث بيانات منتجاته، بما في ذلك الأسعار، التوفر، المخزون، الصور، الأبعاد، التصنيفات، الأوصاف، وروابط المنتجات."
          },
          {
            "type": "paragraph",
            "text": "لا تتحمل زوري أي مسؤولية عن أي خطأ أو نقص أو تضليل أو عدم تحديث في بيانات المنتج المقدمة من التاجر."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري إجراء فحوصات جودة دورية على بيانات المنتجات، وفي حال تكرر وجود مخالفات أو بيانات غير صحيحة أو روابط غير عاملة أو منتجات غير مطابقة، يحق لزوري تعليق حساب التاجر أو إيقاف ظهور منتجاته أو إنهاء اشتراكه دون استرداد أي مبالغ مدفوعة."
          }
        ]
      },
      {
        "title": "المادة 7 – بيانات المنتجات والروابط والتصنيفات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يلتزم التاجر بإدخال البيانات الإلزامية لكل منتج، وتشمل بحد أدنى:"
          },
          {
            "type": "list",
            "items": [
              "اسم المنتج.",
              "السعر.",
              "العملة.",
              "الأبعاد.",
              "التصنيف.",
              "رابط المنتج.",
              "روابط الصور.",
              "أي بيانات إضافية تطلبها زوري بصورة معقولة لتحسين ظهور المنتج أو قراءته أو تحليله."
            ]
          },
          {
            "type": "paragraph",
            "text": "يجب أن تكون المنتجات المدرجة ضمن تصنيفات الأثاث والديكور المعتمدة في زوري، مثل الأثاث، الإضاءة، السجاد، الديكور، الستائر، المرايا، النباتات، الإكسسوارات المنزلية، وأي تصنيفات أخرى تعتمدها زوري من وقت لآخر."
          },
          {
            "type": "paragraph",
            "text": "يحظر على التاجر إدراج أي منتجات خارج نطاق الأثاث والديكور أو خارج التصنيفات المعتمدة في زوري."
          },
          {
            "type": "paragraph",
            "text": "يجب أن تكون المنتجات المدرجة متاحة للبيع فعليًا وموجودة في مخزون التاجر أو متاحة للتوريد من قبله وقت عرضها، ولا يجوز رفع منتجات وهمية أو غير متاحة أو مضللة."
          },
          {
            "type": "paragraph",
            "text": "لا يجوز رفع منتجات بدون سعر، ولا يجوز رفع منتجات مخصصة أو مصممة حسب الطلب، ما لم توافق زوري صراحة على ذلك كتابة."
          },
          {
            "type": "paragraph",
            "text": "يلتزم التاجر بتوفير روابط حقيقية وفعالة ومباشرة لكل منتج، بحيث تنقل المستخدم النهائي إلى صفحة المنتج الفعلية في موقع التاجر."
          },
          {
            "type": "paragraph",
            "text": "في حال كانت الروابط مكسورة أو غير صحيحة أو مضللة أو لا تؤدي إلى صفحة المنتج الفعلية، يحق لزوري حذف المنتج أو تجميده أو تعليق ظهوره أو اتخاذ أي إجراء مناسب دون إشعار مسبق."
          }
        ]
      },
      {
        "title": "المادة 8 – جودة بيانات المنتجات والصور",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يلتزم التاجر بتوفير بيانات وصور بجودة كافية لتمكين أنظمة زوري من قراءة المنتج وتحليله وفهم خصائصه واستخدامه ضمن التصاميم والتوصيات."
          },
          {
            "type": "paragraph",
            "text": "يفضل أن تكون صور المنتجات عالية الجودة، واضحة، غير مشوشة، وتظهر المنتج بصورة تسمح للذكاء الاصطناعي بتحليل اللون والشكل والنمط والأبعاد والاستخدام المحتمل داخل التصميم."
          },
          {
            "type": "paragraph",
            "text": "يدرك التاجر أن ضعف جودة البيانات أو الصور قد يؤثر سلبًا على ظهور المنتج أو ترتيبه أو قدرته على المطابقة داخل التصميمات والمخرجات، ولا تتحمل زوري أي مسؤولية عن ضعف ظهور المنتج الناتج عن نقص أو ضعف بياناته."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري وضع متطلبات فنية أو إرشادات جودة إضافية لبيانات المنتجات أو الصور أو الروابط، ويلتزم التاجر بالامتثال لها خلال المدة التي تحددها زوري."
          }
        ]
      },
      {
        "title": "المادة 9 – ترخيص استخدام المنتجات والمحتوى",
        "blocks": [
          {
            "type": "paragraph",
            "text": "بمجرد رفع المنتجات أو بياناتها أو صورها إلى زوري، يمنح التاجر زوري ترخيصًا عالميًا، غير حصري، قابلًا للاستخدام طوال مدة الاشتراك وبعد انتهائه بالقدر اللازم تقنيًا وتشغيليًا، لاستخدام بيانات المنتجات وصورها وروابطها وأوصافها وعلاماتها التجارية وأي محتوى مرتبط بها داخل المنصة."
          },
          {
            "type": "paragraph",
            "text": "يشمل هذا الترخيص حق زوري في استخدام المنتجات وبياناتها وصورها لأغراض:"
          },
          {
            "type": "list",
            "items": [
              "عرض المنتجات للمستخدمين النهائيين.",
              "إدراج المنتجات ضمن التصاميم والمخرجات.",
              "البحث عن المنتجات.",
              "التوصية بالمنتجات.",
              "الاستبدال الذكي للمنتجات.",
              "التصاميم ثنائية الأبعاد وثلاثية الأبعاد.",
              "تدريب نماذج الذكاء الاصطناعي.",
              "تحسين الخوارزميات وأنظمة التوصية.",
              "تحليل أداء المنتجات والتفاعل معها.",
              "تشغيل المنصة وتحسين خدماتها."
            ]
          },
          {
            "type": "paragraph",
            "text": "يقر التاجر بأن الترخيص الممنوح لزوري لا ينتهي بالنسبة للبيانات أو الصور أو الخصائص أو الأنماط أو المعلومات التي تم استخدامها في تدريب أو تحسين أنظمة الذكاء الاصطناعي أو الخوارزميات، وذلك بالقدر الذي لا يمكن فصله تقنيًا عن النماذج أو الأنظمة التي تم تطويرها."
          },
          {
            "type": "paragraph",
            "text": "يحق للتاجر طلب حذف منتجاته من واجهة المنصة بعد انتهاء الاشتراك، ويؤدي الحذف إلى إزالة المنتجات من العرض النشط والأنظمة التشغيلية للمنصة بحسب الإمكانات الفنية المتاحة، ولا يؤثر ذلك على أي نماذج أو خوارزميات أو نتائج تدريبية أو بيانات مجهولة أو مجمعة سبق استخدامها لتحسين أنظمة زوري."
          }
        ]
      },
      {
        "title": "المادة 10 – استخدام المنتجات في الذكاء الاصطناعي والتصاميم",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يدرك التاجر ويوافق على أن منتجاته قد تستخدم داخل زوري في:"
          },
          {
            "type": "list",
            "items": [
              "التصاميم التي ينشئها المستخدمون النهائيون.",
              "المقترحات الذكية داخل الغرف والمساحات.",
              "نتائج البحث عن المنتجات.",
              "استبدال المنتجات داخل التصميم بمنتجات مشابهة.",
              "التصاميم ثلاثية الأبعاد.",
              "التصاميم ثنائية الأبعاد.",
              "توصيات الأثاث والديكور.",
              "تحسين تجربة المستخدم النهائي.",
              "تدريب وتحسين نماذج الذكاء الاصطناعي والخوارزميات."
            ]
          },
          {
            "type": "paragraph",
            "text": "قد تقوم زوري بمعالجة صور المنتجات تقنيًا، بما في ذلك قص الخلفية، تحسين الجودة، تحليل اللون، تحليل الشكل، تحويل المنتج إلى عنصر رقمي داخل التصميم، أو توليد نسخة ثلاثية الأبعاد أو شبه ثلاثية الأبعاد منه، وذلك لأغراض تشغيل المنصة وتحسين عرض المنتج داخل التصاميم."
          },
          {
            "type": "paragraph",
            "text": "لا تضمن زوري أن يظهر المنتج في كل تصميم أو نتيجة بحث أو توصية، ولا تضمن أن يتم استخدامه أو اختياره من قبل المستخدم النهائي."
          }
        ]
      },
      {
        "title": "المادة 11 – خوارزميات الظهور والترتيب والاستبدال",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يعتمد ظهور منتجات التاجر وترتيبها داخل زوري على خوارزميات المنصة ومعايير المطابقة والتحليل التي تعتمدها زوري من وقت لآخر."
          },
          {
            "type": "paragraph",
            "text": "تشمل عوامل الظهور والترتيب، على سبيل المثال لا الحصر:"
          },
          {
            "type": "list",
            "items": [
              "اللون.",
              "الشكل.",
              "المقاسات.",
              "نوع المنتج.",
              "النمط التصميمي.",
              "التوفر.",
              "جودة بيانات المنتج.",
              "جودة الصور.",
              "ملاءمة المنتج للتصميم.",
              "مدى تطابق المنتج مع العنصر الموجود داخل التصميم.",
              "أداء المنتج وتفاعلات المستخدمين معه.",
              "أي عوامل تقنية أو تشغيلية أخرى تحددها زوري."
            ]
          },
          {
            "type": "paragraph",
            "text": "إذا تطابق منتج التاجر مع المنتج أو العنصر المطلوب داخل التصميم، فقد يتم إظهاره في بداية النتائج أو ضمن النتائج المتقدمة حسب درجة المطابقة."
          },
          {
            "type": "paragraph",
            "text": "إذا كان هناك منتج آخر من تاجر آخر أكثر تطابقًا من حيث اللون أو الشكل أو النمط أو المقاسات أو الملاءمة التصميمية، فيجوز لخوارزميات زوري إظهار ذلك المنتج قبل منتج التاجر."
          },
          {
            "type": "paragraph",
            "text": "يدرك التاجر أن هذه هي آلية عمل خوارزميات زوري، وأن الاشتراك في المنصة لا يمنح التاجر حقًا مضمونًا في الظهور الأول أو الترتيب الأعلى أو الأولوية المطلقة."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري تغيير أو تعديل أو تحسين خوارزميات الظهور والترتيب والاستبدال في أي وقت دون إشعار مسبق، ودون أن يترتب على ذلك أي حق للتاجر في الاعتراض أو المطالبة بتعويض أو استرداد."
          },
          {
            "type": "paragraph",
            "text": "قد تقدم زوري باقات أو مزايا إضافية تمنح أولوية ظهور أو فرص عرض محسنة، إلا أن تلك الأولوية تظل خاضعة لمعايير المطابقة الخوارزمية وملاءمة المنتج للتصميم، ولا تعني عرض منتج غير مناسب أو غير مطابق قبل منتج أكثر ملاءمة للتصميم."
          }
        ]
      },
      {
        "title": "المادة 12 – التحليلات والتفاعل والتحويل",
        "blocks": [
          {
            "type": "paragraph",
            "text": "توفر زوري للتاجر، بحسب الباقة أو آلية الربط أو الإمكانات التقنية المتاحة، بيانات وتحليلات من خلال لوحة التحكم تتعلق بتفاعل المستخدمين النهائيين مع منتجاته."
          },
          {
            "type": "paragraph",
            "text": "قد تشمل التحليلات، بحسب ما تتيحه المنصة:"
          },
          {
            "type": "list",
            "items": [
              "مشاهدات المنتج.",
              "النقرات على المنتج.",
              "التحويل إلى صفحة المنتج في موقع التاجر.",
              "الأداء حسب الأيام.",
              "المنتجات الأكثر تفاعلًا.",
              "سلوك المستخدم المرتبط بالمنتجات داخل المنصة.",
              "أي مؤشرات إضافية توفرها زوري من وقت لآخر."
            ]
          },
          {
            "type": "paragraph",
            "text": "يعرف التحويل، لأغراض هذه الشروط، بأنه انتقال المستخدم النهائي من منصة زوري إلى صفحة المنتج في موقع التاجر."
          },
          {
            "type": "paragraph",
            "text": "إذا كان التاجر يرفع منتجاته مباشرة عبر زوري دون ربط تقني، تقيس زوري التحويلات والتفاعلات المتاحة داخل المنصة أو من خلالها."
          },
          {
            "type": "paragraph",
            "text": "إذا تم الربط عبر API أو أي آلية تتبع معتمدة، قد تتمكن زوري من قياس الدخول إلى صفحة المنتج لدى التاجر وتتبع بعض السلوكيات المرتبطة بالمنتج، مثل مشاهدة المنتج أو النقر أو الإضافة إلى السلة أو إتمام الشراء أو قيمة الطلب، وذلك بحسب ما يسمح به الربط التقني والبيانات المتاحة."
          },
          {
            "type": "paragraph",
            "text": "تكون التحليلات المعروضة في لوحة التحكم مباشرة وتعكس السلوك بحسب الأيام وبحسب البيانات المتاحة لزوري."
          },
          {
            "type": "paragraph",
            "text": "رغم أن زوري تبذل جهودًا معقولة لتقديم تحليلات دقيقة، فإن أي أرقام أو تقارير أو مؤشرات أداء قد تتأثر بعوامل تقنية أو تكاملات خارجية أو أدوات تتبع أو إعدادات المتصفح أو موقع التاجر، ولا تعد ضمانًا لأي نتيجة تجارية."
          }
        ]
      },
      {
        "title": "المادة 13 – الربط التقني وواجهات API",
        "blocks": [
          {
            "type": "paragraph",
            "text": "الربط عبر API اختياري، ولا يعد شرطًا أساسيًا لاستخدام التاجر للمنصة، ما لم يتم الاتفاق كتابة على خلاف ذلك."
          },
          {
            "type": "paragraph",
            "text": "إذا اختار التاجر الربط عبر API، يكون مسؤولًا عن التكاليف الفنية والتشغيلية المرتبطة بالربط والصيانة من جانبه، بما في ذلك جاهزية أنظمته، دقة البيانات، أمن مفاتيح الربط، واستمرارية الروابط."
          },
          {
            "type": "paragraph",
            "text": "في حال الربط عبر API، يمنح التاجر زوري الحق في الوصول إلى البيانات المتاحة من خلال الربط والمتعلقة بأداء المنتجات وسلوك المستخدمين المرتبط بها، بما في ذلك مشاهدة المنتج، النقر، الإضافة إلى السلة، إتمام الشراء، وقيمة الطلب، بحسب ما تتيحه أنظمة التاجر والربط المتفق عليه."
          },
          {
            "type": "paragraph",
            "text": "لا تجمع زوري بيانات المستخدم النهائي من موقع التاجر إلا في حدود تتبع رابط الإحالة أو البيانات الفنية اللازمة لقياس التحويلات والتفاعل، ما لم يتم الاتفاق على خلاف ذلك كتابة وبما يتوافق مع الأنظمة المعمول بها."
          },
          {
            "type": "paragraph",
            "text": "في حال تعطل الربط التقني أو تعذر الاتصال بالـ API، تسعى الأطراف إلى إصلاح الخلل، ويظل تحويل المستخدم النهائي إلى صفحة المنتج في موقع التاجر قائمًا متى كان الرابط متاحًا ويعمل بصورة صحيحة."
          },
          {
            "type": "paragraph",
            "text": "لا تتحمل زوري أي مسؤولية عن تعطل أنظمة التاجر أو API الخاص به أو الروابط أو البيانات التي يوفرها، ولا عن أي نقص أو انقطاع في التحليلات الناتج عن ذلك."
          }
        ]
      },
      {
        "title": "المادة 14 – عدم ضمان المبيعات أو التحويلات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يدرك التاجر أن فائدة المنصة تتمثل في تمكين المستخدمين النهائيين من التفاعل مع منتجاته، ورؤية تلك المنتجات داخل التصاميم، والانتقال إلى صفحة المنتج في موقع التاجر متى كان المنتج مناسبًا ومطابقًا لاحتياج التصميم."
          },
          {
            "type": "paragraph",
            "text": "لا تضمن زوري أي مبيعات أو إيرادات أو عدد زيارات أو عدد نقرات أو عدد تحويلات أو معدل تحويل معين."
          },
          {
            "type": "paragraph",
            "text": "لا يعد ظهور المنتج داخل التصميم أو نتائج البحث أو الاستبدال الذكي أو لوحة التوصيات وعدًا من زوري بتحقيق بيع أو طلب أو ربح أو عائد تجاري."
          },
          {
            "type": "paragraph",
            "text": "يتحمل التاجر وحده مسؤولية تحويل الزيارات إلى مبيعات داخل موقعه أو قنواته، بما في ذلك تجربة المستخدم في موقعه، الأسعار، المخزون، الدفع، الشحن، خدمة العملاء، وسياسات الإرجاع والاستبدال."
          }
        ]
      },
      {
        "title": "المادة 15 – مسؤوليات التاجر تجاه المستخدم النهائي",
        "blocks": [
          {
            "type": "paragraph",
            "text": "لا تتم عملية الشراء داخل زوري، وإنما يتم تحويل المستخدم النهائي إلى صفحة المنتج في موقع التاجر أو قنواته الرسمية."
          },
          {
            "type": "paragraph",
            "text": "زوري ليست طرفًا في أي عملية شراء تتم بين المستخدم النهائي والتاجر، ولا تتحمل أي مسؤولية عن السعر، التوفر، الدفع، الشحن، التوصيل، التركيب، الإرجاع، الاستبدال، الضمان، جودة المنتج، أو أي مطالبة تنشأ بين المستخدم النهائي والتاجر."
          },
          {
            "type": "paragraph",
            "text": "يتحمل التاجر وحده مسؤولية صحة الأسعار، توفر المنتجات، شروط البيع، تنفيذ الطلبات، معالجة المدفوعات، خدمة العملاء، الشحن، التوصيل، الإرجاع، الاستبدال، الضمان، وأي التزامات نظامية أو تجارية تجاه المستخدم النهائي."
          },
          {
            "type": "paragraph",
            "text": "في حال اشترى المستخدم النهائي منتجًا من موقع التاجر وحدثت أي مشكلة أو نزاع أو مطالبة، تكون العلاقة مباشرة بين المستخدم النهائي والتاجر، وتكون زوري خارج هذه العلاقة تمامًا."
          }
        ]
      },
      {
        "title": "المادة 16 – الملكية الفكرية وحقوق المنتجات والصور",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يتحمل التاجر وحده المسؤولية عن أي تجاوز أو مخالفة تتعلق بالملكية الفكرية أو العلامات التجارية أو حقوق الصور أو أوصاف المنتجات أو أي محتوى يرفعه إلى زوري."
          },
          {
            "type": "paragraph",
            "text": "لا تتحمل زوري أي مسؤولية عن أي مطالبة أو نزاع أو ضرر أو خسارة ناتجة عن استخدام التاجر لصور أو أوصاف أو علامات أو بيانات منتجات لا يملك حق استخدامها أو لا يملك الصلاحية النظامية لعرضها."
          },
          {
            "type": "paragraph",
            "text": "يحق لزوري استخدام اسم التاجر وشعاره وعلامته التجارية داخل المنصة، وفي العروض التجارية، والمواد التسويقية، وقوائم الشركاء، وأي مواد تعريفية مرتبطة بالمنصة، دون الحاجة إلى موافقة منفصلة، ما لم يتم الاتفاق كتابة على خلاف ذلك."
          },
          {
            "type": "paragraph",
            "text": "تبقى منصة زوري وخوارزمياتها ونماذجها وأنظمتها وواجهاتها وتصاميمها وبرمجياتها وطرق عرضها وأنظمة التوصية والترتيب والاستبدال مملوكة لزوري أو مرخصة لها، ولا تنتقل إلى التاجر أي حقوق ملكية فكرية فيها بموجب هذه الشروط."
          }
        ]
      },
      {
        "title": "المادة 17 – المنتجات المحظورة والمحتوى المخالف",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يحظر على التاجر رفع أو إدراج أي منتجات خارج تصنيفات الأثاث والديكور المعتمدة في زوري."
          },
          {
            "type": "paragraph",
            "text": "كما يحظر على التاجر رفع أو إدراج أي منتج أو محتوى:"
          },
          {
            "type": "list",
            "items": [
              "مخالف للأنظمة المعمول بها.",
              "مقلد أو منتهك لحقوق الغير.",
              "مضلل أو غير صحيح.",
              "غير متاح للبيع فعليًا.",
              "يحتوي على روابط غير حقيقية أو غير عاملة.",
              "خارج نطاق تصنيفات زوري.",
              "يسيء إلى المستخدمين أو يخالف الآداب العامة.",
              "قد يضر بسمعة زوري أو تجربة المستخدم النهائي."
            ]
          },
          {
            "type": "paragraph",
            "text": "يحق لزوري حذف أو تجميد أو تقييد أي منتج مخالف فورًا ودون إشعار مسبق، سواء بإنهاء حساب التاجر أو دون إنهائه."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري تجميد بعض المنتجات لحين التحقق منها أو لحين اكتمال تدريب أنظمة الذكاء الاصطناعي عليها أو تحسين"
          }
        ]
      },
      {
        "title": "المادة 18 – عدم الالتفاف وعدم المنافسة",
        "blocks": [
          {
            "type": "paragraph",
            "text": "لا يجوز للتاجر استخدام المنصّة أو لوحة التحكم أو أي بيانات أو تحليلات أو آليات يحصل عليها من زوري لأغراض بناء أو تطوير أو دعم أو تشغيل خدمة أو منصّة منافسة لزوري، أو لتقليد خوارزمياتها أو أنظمتها أو طرق عرضها."
          },
          {
            "type": "paragraph",
            "text": "لا يجوز للتاجر محاولة الالتفاف على المنصّة أو آليّاتها التقنية أو التجارية بقصد استغلال بياناتها أو علاقتها بالمستخدمين النهائيين خارج النطاق المصرّح به في هذه الشروط."
          }
        ]
      },
      {
        "title": "المادة 19 – التعليق والحذف والإنهاء",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يجوز لزوري تعليق حساب التاجر أو تقييد وصوله أو حذف منتجاته أو تجميدها أو إنهاء اشتراكه فورًا ودون استرداد في أي من الحالات التالية:"
          },
          {
            "type": "list",
            "items": [
              "عدم سداد رسوم الاشتراك.",
              "وجود روابط مكسورة أو مضللة أو غير حقيقية.",
              "تقديم بيانات منتجات غير صحيحة أو مضللة.",
              "رفع منتجات خارج التصنيفات المعتمدة.",
              "تكرار شكاوى المستخدمين النهائيين.",
              "مخالفة حقوق الملكية الفكرية أو الخصوصية أو الأنظمة.",
              "إساءة استخدام لوحة التحكم أو المنصة.",
              "محاولة التلاعب بالخوارزميات أو التحليلات.",
              "إدخال بيانات أو ملفات أو أكواد ضارة.",
              "مخالفة هذه الشروط أو الاتفاقية التجارية."
            ]
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري حذف المنتجات المخالفة أو تجميدها فورًا دون منح مهلة تصحيح، متى رأت أن ذلك ضروري لحماية المنصة أو المستخدمين أو جودة الخدمة أو الامتثال النظامي."
          },
          {
            "type": "paragraph",
            "text": "لا يترتب على التعليق أو الحذف أو الإنهاء بسبب مخالفة التاجر أي حق في استرداد رسوم الاشتراك أو المطالبة بتعويض."
          },
          {
            "type": "paragraph",
            "text": "عند إنهاء الاشتراك لأي سبب، يستمرّ وصول التاجر إلى لوحة التحكم لمدّة شهر واحد (1) من تاريخ الإنهاء لغرض الاطلاع على بياناته وتنزيلها، وبعد انقضاء هذه المدّة يُوقَف الوصول إلى لوحة التحكم بصورة نهائية. ويظل احتفاظ زوري بأي بيانات لأغراض نظامية أو محاسبية أو ضريبية أو أمنية خاضعًا للأنظمة المعمول بها."
          }
        ]
      },
      {
        "title": "المادة 20 – الاتفاقيات الموقعة",
        "blocks": [
          {
            "type": "paragraph",
            "text": "إذا وجدت اتفاقية تجارية موقعة بين زوري والتاجر، فإنها تعد مكملة لهذه الشروط."
          },
          {
            "type": "paragraph",
            "text": "في حال التعارض بين هذه الشروط والاتفاقية التجارية الموقعة، تسود الاتفاقية التجارية في الأحكام التجارية الخاصة، مثل الرسوم، الباقة، مدة الاشتراك، عدد المنتجات، مزايا العرض، أو أي مزايا تجارية خاصة تم الاتفاق عليها كتابة."
          },
          {
            "type": "paragraph",
            "text": "أما الأحكام العامة والتشغيلية والتقنية والقانونية المتعلقة باستخدام المنصة، ولوحة التحكم، والخوارزميات، والبيانات، والمسؤوليات، وحدود الضمان، والتعليق، والإنهاء، فتظل هذه الشروط سارية ما لم تنص الاتفاقية التجارية صراحة على خلاف ذلك."
          }
        ]
      },
      {
        "title": "المادة 21 – السرية والبيانات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يلتزم كل طرف بالمحافظة على سرية المعلومات غير العامة التي يحصل عليها من الطرف الآخر بمناسبة العلاقة التجارية، بما في ذلك المعلومات التجارية والفنية والأسعار غير المنشورة وبيانات الأداء وأي معلومات يتم وصفها أو يفترض منطقيًا أنها سرية."
          },
          {
            "type": "paragraph",
            "text": "لا يجوز للتاجر استخدام أي بيانات أو معلومات يحصل عليها من لوحة التحكم أو المنصة إلا لأغراض متابعة أداء منتجاته داخل زوري وتحسين بياناتها وتجربتها."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري استخدام بيانات المنتجات والتفاعل والتحويل والتحليلات لأغراض تشغيل المنصة، تحسين الخوارزميات، تطوير المنتج، إعداد التقارير، قياس الأداء، وتحسين تجربة المستخدم النهائي، بما في ذلك استخدام بيانات مجهولة المصدر أو مجمعة."
          },
          {
            "type": "paragraph",
            "text": "لا يجوز للتاجر محاولة الوصول إلى بيانات تخص تجارًا آخرين أو مستخدمين نهائيين أو أنظمة زوري أو أي بيانات غير مصرح له بالوصول إليها."
          }
        ]
      },
      {
        "title": "المادة 22 – حماية البيانات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "تلتزم زوري ببذل عناية معقولة لحماية البيانات التي تعالجها في إطار تشغيل المنصّة، وتطبيق تدابير تقنية وتنظيمية مناسبة للحفاظ على أمنها."
          },
          {
            "type": "paragraph",
            "text": "يقرّ التاجر بأن منصّة زوري قائمة على عرض منتجات الأثاث والديكور، وأنه يلتزم بألّا تتضمّن الصور أو البيانات أو المحتوى الذي يرفعه أي بيانات شخصية لأي شخص. ويتحمّل التاجر وحده كامل المسؤولية النظامية في حال تضمّن المحتوى المقدَّم منه أي بيانات شخصية، ويُبرئ زوري من أي مطالبة أو ضرر ينشأ عن ذلك."
          }
        ]
      },
      {
        "title": "المادة 23 – إخلاء المسؤولية وحدود الضمان",
        "blocks": [
          {
            "type": "paragraph",
            "text": "تقدم زوري خدماتها ولوحة التحكم والخوارزميات والتحليلات وأدوات العرض “كما هي” و“كما هي متاحة”، دون أي ضمان بأن منتجات التاجر ستظهر في ترتيب معين أو تحقق تحويلات أو مبيعات أو نتائج تجارية محددة."
          },
          {
            "type": "paragraph",
            "text": "لا تضمن زوري أن تكون الخوارزميات أو التحليلات أو بيانات التفاعل خالية من الأخطاء أو متاحة بشكل دائم أو مناسبة لغرض تجاري معين لدى التاجر."
          },
          {
            "type": "paragraph",
            "text": "لا تتحمل زوري أي مسؤولية عن أي خسارة مباشرة أو غير مباشرة أو تبعية أو خسارة أرباح أو فقدان فرص تجارية أو انخفاض مبيعات أو ضعف أداء تجاري ناتج عن استخدام التاجر للمنصة أو اعتماده على التحليلات أو الخوارزميات أو نتائج الظهور."
          },
          {
            "type": "paragraph",
            "text": "لا تتحمل زوري أي مسؤولية عن منتجات التاجر أو محتواه أو روابطه أو موقعه أو عملية البيع أو علاقته بالمستخدم النهائي."
          },
          {
            "type": "paragraph",
            "text": "إلى أقصى حد يسمح به النظام، يكون الحد الأقصى لمسؤولية زوري، إن وجدت وثبتت بحكم نهائي، مقصورًا على المبالغ التي دفعها التاجر لزوري عن آخر مدة اشتراك سنوية، ولا يشمل ذلك أي أضرار غير مباشرة أو تبعية أو فقدان أرباح أو فرص."
          }
        ]
      },
      {
        "title": "المادة 24 – التعويض",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يلتزم التاجر بالدفاع عن زوري وشركتها ومالكيها ومديريها وموظفيها ومزوّدي خدماتها وتعويضهم وإبراء ذمّتهم من أي مطالبات أو دعاوى أو أضرار أو خسائر أو غرامات أو تكاليف أو مصاريف، بما في ذلك الأتعاب القانونية المعقولة، الناشئة عن أو المتعلقة بأيٍّ مما يلي:"
          },
          {
            "type": "list",
            "items": [
              "إخلال التاجر بهذه الشروط أو بأي إقرار أو ضمان وارد فيها.",
              "منتجات التاجر أو بياناتها أو صورها أو أوصافها أو علاماتها التجارية أو روابطها.",
              "مخالفة التاجر لحقوق الملكية الفكرية أو حقوق الغير أو الأنظمة المعمول بها.",
              "علاقة التاجر بالمستخدم النهائي، بما في ذلك البيع والتوريد والشحن والإرجاع والضمان وخدمة العملاء.",
              "تضمّن المحتوى المقدَّم من التاجر أي بيانات شخصية.",
              "أي وصول غير مصرّح به ناتج عن إهمال التاجر أو مشاركته لبيانات الدخول."
            ]
          }
        ]
      },
      {
        "title": "المادة 25 – القوة القاهرة",
        "blocks": [
          {
            "type": "paragraph",
            "text": "لا تتحمل زوري أي مسؤولية عن أي تأخير أو فشل أو انقطاع أو ضعف في الأداء ناتج عن أحداث خارجة عن سيطرتها المعقولة، بما في ذلك أعطال الإنترنت، أعطال مزودي الخدمات السحابية، أعطال مزودي الذكاء الاصطناعي، أعطال بوابات الدفع، الهجمات السيبرانية، الكوارث الطبيعية، الإجراءات الحكومية، أو أي ظروف قاهرة أخرى."
          }
        ]
      },
      {
        "title": "المادة 26 – الإخطارات وقنوات التواصل الرسمية",
        "blocks": [
          {
            "type": "paragraph",
            "text": "يجوز لزوري توجيه الإخطارات إلى التاجر عبر المنصّة أو لوحة التحكم أو البريد الإلكتروني أو الموقع أو أي قناة تواصل معتمدة. ويتحمّل التاجر مسؤولية الحفاظ على بيانات تواصله صحيحة ومحدّثة."
          },
          {
            "type": "paragraph",
            "text": "تُقدَّم جميع الإخطارات والطلبات والمراسلات التعاقدية الرسمية عبر القناة الرسمية المعتمدة: support@zory.ai، وذلك"
          }
        ]
      },
      {
        "title": "المادة 27 – القانون الواجب التطبيق وتسوية النزاعات",
        "blocks": [
          {
            "type": "paragraph",
            "text": "تخضع هذه الشروط وتفسر وفق أنظمة المملكة العربية السعودية."
          },
          {
            "type": "paragraph",
            "text": "يسعى الطرفان أولًا إلى تسوية أي نزاع ينشأ عن هذه الشروط أو العلاقة التجارية بينهما بصورة ودية خلال ثلاثين (30) يومًا تقويميًا من تاريخ إخطار أحد الطرفين الطرف الآخر بالنزاع."
          },
          {
            "type": "paragraph",
            "text": "إذا تعذر حل النزاع وديًا خلال تلك المدة، تختص المحاكم المختصة في المملكة العربية السعودية بالنظر في النزاع، ما لم تنص اتفاقية تجارية موقعة على خلاف ذلك بما لا يخالف الأنظمة المعمول بها."
          }
        ]
      },
      {
        "title": "المادة 28 – أحكام عامة",
        "blocks": [
          {
            "type": "paragraph",
            "text": "تشكل هذه الشروط، مع أي اتفاقية تجارية موقعة والسياسات المشار إليها، الإطار المنظم لعلاقة التاجر بزوري فيما يتعلق بإدراج المنتجات واستخدامها داخل المنصة."
          },
          {
            "type": "paragraph",
            "text": "إذا تبين بطلان أو عدم قابلية أي بند من هذه الشروط للتنفيذ، تبقى بقية البنود سارية ونافذة، ويستبدل البند الباطل أو غير القابل للتنفيذ ببند مشروع يحقق القصد التجاري الأصلي قدر الإمكان."
          },
          {
            "type": "paragraph",
            "text": "عدم ممارسة زوري لأي حق من حقوقها بموجب هذه الشروط لا يعد تنازلًا عن ذلك الحق."
          },
          {
            "type": "paragraph",
            "text": "لا يجوز للتاجر التنازل عن حقوقه أو التزاماته بموجب هذه الشروط دون موافقة كتابية مسبقة من زوري، بينما يجوز لزوري التنازل عنها أو نقلها ضمن أي إعادة هيكلة أو اندماج أو استحواذ أو نقل أعمال."
          },
          {
            "type": "paragraph",
            "text": "يجوز لزوري تعديل هذه الشروط من وقت لآخر، وتنشر النسخة المحدثة عبر المنصة أو الموقع أو لوحة التحكم أو ترسل إلى التاجر عبر وسائل التواصل المعتمدة. ويعد استمرار التاجر في استخدام المنصة بعد سريان التحديث قبولًا منه بالشروط المعدلة."
          },
          {
            "type": "paragraph",
            "text": "النسخة العربية هي النسخة المعتمدة والمسيطرة لهذه الشروط، وفي حال إعداد نسخة إنجليزية أو أي ترجمة أخرى، تكون لأغراض التيسير فقط، وتسود النسخة العربية عند أي تعارض."
          }
        ]
      }
    ]
  }
};
